exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-input__inner{border:1px solid #ced4da;border-radius:0}", ""]);

// exports
